// //使い方
// import SpanWrap from "../../plugins/spanWrap.js";
// // spanWrap.init();
// const targets = [...document.querySelectorAll(".js-spnaWrap")]

// targets.forEach( (target) => {
//   new SpanWrap(target);
// })
// // new SpanWrap($(".js-spnaWrap"));
// // $(".js-spnaWrap").each(function(i, v){
// // })


